import { makeStyles } from '@material-ui/styles';

export default makeStyles(() => ({
  text: {
    fontSize: 24,
  },
}));



// WEBPACK FOOTER //
// ./src/sharedComponents/MothlyPaymentCalculator/components/DesktopCalculationsResult/useStyles.js